export default __webpack_public_path__ + "static/media/approval.8bf4887d.svg";